export default __webpack_public_path__ + "static/media/TokiRGB_orange.79c32701.png";